module.exports = __webpack_public_path__ + "img/device.d5740af6.svg";